import { ArrowUpIcon } from 'lucide-react';
import { Button } from './ui';
import { cn } from '../utils';

type Props = {
  className?: string;
  onClick: () => void;
};

export const ScrollTopButton = ({ className, onClick }: Props) => {
  return (
    <Button
      variant="carousel"
      className={cn(
        'min-w-[5.6rem] w-[5.6rem] h-[5.6rem] rounded-full p-0',
        className
      )}
      onClick={onClick}>
      <ArrowUpIcon />
    </Button>
  );
};
